import React from 'react';
import { Box } from '@material-ui/core';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { loginValidationSchema } from '../validation';
import { LoginEmployee } from '../../../../../server-types';
import { InputField } from '../../../../../components/forms/fields';
import FormWrapper from '../../../../../components/forms/FormWrapper';
import { Card } from '../../../../../ui-kit';

interface LoginFormInitialValues {
    email: string;
    password: string;
}

export interface LoginFormProps {
    onSubmit: (values: LoginEmployee) => Promise<void>;
    initialValues?: LoginFormInitialValues;
}

const LoginFormView = ({
    onSubmit,
    initialValues = {
        email: '',
        password: '',
    },
}: LoginFormProps) => {
    const { t } = useTranslation();
    return (
        <Card>
            <Box px={3} py={5}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={loginValidationSchema}
                    onSubmit={onSubmit}
                >
                    {formikProps => (
                        <FormWrapper
                            submitText={t('Login') as unknown as string}
                            isSubmitting={formikProps.isSubmitting}
                        >
                            <InputField<LoginFormInitialValues>
                                name="email"
                                label={t('Login')}
                                formikProps={formikProps}
                                required
                            />
                            <InputField<LoginFormInitialValues>
                                name="password"
                                type="password"
                                label={t('Password')}
                                formikProps={formikProps}
                                required
                            />
                        </FormWrapper>
                        )}
                </Formik>
            </Box>
        </Card>
    );
};


export default LoginFormView;
